import React from 'react';
import { useWebsiteSettingsOptional, resolveMediaUrl } from '../contexts/WebsiteSettingsContext';

const Logo = ({ size = 'default', className = '', alt }) => {
  const heights = {
    small: 'h-10',
    default: 'h-16 md:h-20',
    large: 'h-24 md:h-32',
  };

  const h = heights[size] || heights.default;
  const ctx = useWebsiteSettingsOptional();
  const logoUrl = ctx?.settings?.logoUrl;
  const src = logoUrl ? resolveMediaUrl(logoUrl) : '/favicon.svg';
  const label = alt || (ctx ? ctx.siteName('en') : 'Hydrabad Karnataka');

  return (
    <div className={`inline-block bg-white ${className}`} data-testid="site-logo-svg">
      <img
        src={src}
        alt={label}
        className={`${h} w-auto object-contain block`}
        loading="eager"
      />
    </div>
  );
};

export default Logo;
